/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/

(async function() {
  // Add custom code below this line
  const freeGiftStartTime = new Date(window.theme.settings.freeGiftStartTime)
  const freeGiftEndTime = new Date(window.theme.settings.freeGiftEndTime)
  const today = new Date()

  const handleFreeGift = async () => {
    let shouldHaveGift = false;
    let hasGift = false;
    let autoGiftLines = []
    let autoGiftLineItemKey = ""
    let cart = {}

    try {
      cart = window.cartResponse
    } catch (error) {
      cart = await fetch(`${window.Shopify.routes.root}cart.js`).then(response => response.json())
        .catch(fetchError => {
          console.error('GWP: ❌ cart.js fetch failed', fetchError)
          throw fetchError
        })
    }

    if (!gwpConfig) {
      console.warn('GWP: ⚠️ missing configuration, skipping gift logic')
      return
    }

    const giftVariantId = gwpConfig.gift_variant.split("/").pop();
    let giftQuantity = 1
    let giftLineQuantity = 0

    if (gwpConfig.type == "Spend-Based") {
      const THRESHOLD = gwpConfig.minimum_spend * 100;
      
      let cartTotal = 0;
      
      cart.items.forEach(item => {
        if (giftVariantId && item.variant_id == giftVariantId) {
          if (item.properties._Gifted && item.properties._Gifted == "GWP") {
            hasGift = true;
            giftLineQuantity = item.quantity;
            
            autoGiftLines.push({
              autoGiftLineItemKey: item.key,
              quantity: item.quantity  
            })
            cartTotal -= item.final_line_price;
          }
        }
        cartTotal += item.final_line_price;
      });
  
      if (today > freeGiftStartTime && today < freeGiftEndTime) {
        shouldHaveGift = cartTotal >= THRESHOLD
        console.info('GWP: 🧮 spend check')
        console.table([{ cartTotal, threshold: THRESHOLD, shouldHaveGift, hasGift }])
      }
    } else if (gwpConfig.type == "Product-Specific") {
      if (!gwpConfig.only_1_gift) {
        giftQuantity = 0;
      }
      cart.items.forEach(item => {
        if (!item.properties._Gifted) {
          if (gwpConfig.specific_products.map(gid => gid.split("/").pop()).includes(item.product_id.toString())) {
            shouldHaveGift = true
            giftQuantity += item.quantity
          }
        } else if (item.variant_id == giftVariantId && item.properties._Gifted && item.properties._Gifted == "GWP") {
          hasGift = true
          giftLineQuantity += item.quantity;

          autoGiftLines.push({
            autoGiftLineItemKey: item.key,
            price: item.final_line_price,
            quantity: item.quantity
          })
        }
      })
      console.info('GWP: 🎯 product check', { shouldHaveGift, hasGift, autoGiftLineItemKey })
    }
    
    if (today > freeGiftStartTime && today < freeGiftEndTime) {
      if (shouldHaveGift) {
        if (hasGift) {
          if (giftQuantity != giftLineQuantity) {
            const updates = {};
            autoGiftLines.forEach(giftLine => {
              if (giftLine.price > 0) {
                updates[giftLine.autoGiftLineItemKey] = 0
              } else {
                updates[giftLine.autoGiftLineItemKey] = giftQuantity
              }
            })

            console.info('GWP: 🧹 updating gift', autoGiftLines)
            fetch('/cart/update.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({updates})
            })
            .then( res => res.json())
            .finally(() => {
              document.querySelector("cart-items").getCart()
            });
          }
        } else {
          const items = [
            {
              quantity: giftQuantity,
              id: giftVariantId,
              properties: {
                '_Gifted': "GWP"
              }
            }
          ]
          console.info('GWP: 🎁 adding gift', { giftVariantId })
          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({items})
          })
          .then( res => res.json())
          .finally(() => {
            document.querySelector("cart-items").getCart()
          });
        }
      } else if (!shouldHaveGift && hasGift) {
        if (autoGiftLines.length) {
          const updates = {};
          autoGiftLines.forEach(giftLine => {
            updates[giftLine.autoGiftLineItemKey] = 0
          })

          console.info('GWP: 🧹 removing gift', autoGiftLines)
          fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({updates})
          })
          .then( res => res.json())
          .finally(() => {
            document.querySelector("cart-items").getCart()
          });
        }
      }
    }
    else {
      if (hasGift) {
        if (autoGiftLines.length) {
          const updates = {};
          autoGiftLines.forEach(giftLine => {
            updates[giftLine.autoGiftLineItemKey] = 0
          })

          console.info('GWP: 🧹 removing gift', autoGiftLines)
          fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({updates})
          })
          .then( res => res.json())
          .finally(() => {
            document.querySelector("cart-items").getCart()
          });
        }
      }
    }
  }

  document.addEventListener("theme:cart:change", handleFreeGift);
  
  handleFreeGift();

  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();

